import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: '1', label: 'Far North District' },
    { value: '2', label: 'Whangarei District' },
    { value: '3', label: 'Kaipara District' },
    { value: '4', label: 'Rodney District' },
    { value: '5', label: 'North Shore City' },
    { value: '6', label: 'Waitakere City' },
    { value: '7', label: 'Auckland City' },
    { value: '8', label: 'Manukau City' },
    { value: '9', label: 'Papakura District' },
    { value: '10', label: 'Franklin District' },
    { value: '11', label: 'Thames-Coromandel District' },
    { value: '12', label: 'Hauraki District' },
    { value: '13', label: 'Waikato District' },
    { value: '15', label: 'Matamata-Piako District' },
    { value: '16', label: 'Hamilton City' },
    { value: '17', label: 'Waipa District' },
    { value: '18', label: 'Otorohanga District' },
    { value: '19', label: 'South Waikato District' },
    { value: '20', label: 'Waitomo District' },
    { value: '21', label: 'Taupo District' },
    { value: '22', label: 'Western Bay of Plenty District' },
    { value: '23', label: 'Tauranga District' },
    { value: '24', label: 'Rotorua District' },
    { value: '25', label: 'Whakatane District' },
    { value: '26', label: 'Kawerau District' },
    { value: '27', label: 'Opotiki District' },
    { value: '28', label: 'Gisborne District' },
    { value: '29', label: 'Wairoa District' },
    { value: '30', label: 'Hastings District' },
    { value: '31', label: 'Napier City' },
    { value: '32', label: 'Central Hawkes Bay District' },
    { value: '33', label: 'New Plymouth District' },
    { value: '34', label: 'Stratford District' },
    { value: '35', label: 'South Taranaki District' },
    { value: '36', label: 'Ruapehu District' },
    { value: '37', label: 'Wanganui District' },
    { value: '38', label: 'Rangitikei District' },
    { value: '39', label: 'Manawatu District' },
    { value: '40', label: 'Palmerston North City' },
    { value: '41', label: 'Tararua District' },
    { value: '42', label: 'Horowhenua District' },
    { value: '43', label: 'Kapiti Coast District' },
    { value: '44', label: 'Porirua City' },
    { value: '45', label: 'Upper Hutt City' },
    { value: '46', label: 'Lower Hutt City' },
    { value: '47', label: 'Wellington City' },
    { value: '48', label: 'Masterton District' },
    { value: '49', label: 'Carterton District' },
    { value: '50', label: 'South Wairarapa District' },
    { value: '51', label: 'Tasman District' },
    { value: '52', label: 'Nelson City' },
    { value: '53', label: 'Marlborough District' },
    { value: '54', label: 'Kaikoura District' },
    { value: '55', label: 'Buller District' },
    { value: '56', label: 'Grey District' },
    { value: '57', label: 'Westland District' },
    { value: '58', label: 'Hurunui District' },
    { value: '59', label: 'Waimakariri District' },
    { value: '60', label: 'Christchurch City' },
    { value: '61', label: 'Banks Peninsula District' },
    { value: '62', label: 'Selwyn District' },
    { value: '63', label: 'Ashburton District' },
    { value: '64', label: 'Timaru District' },
    { value: '65', label: 'McKenzie District' },
    { value: '66', label: 'Waimate District' },
    { value: '67', label: 'Chatham Islands County' },
    { value: '68', label: 'Waitaki District' },
    { value: '69', label: 'Central Otago District' },
    { value: '70', label: 'Queenstown-Lakes District' },
    { value: '71', label: 'Dunedin City' },
    { value: '72', label: 'Clutha District' },
    { value: '73', label: 'Southland District' },
    { value: '74', label: 'Gore District' },
    { value: '75', label: 'Invercargill City' },
    { value: '999', label: 'Area Outside Territorial Authority' },
  ],
});
